//TODO: hmm

export const HMM_INTERESTING_LABEL = "Hmm Interesting";
export const SAY_WHAT_LABEL = "Say what?";
export const GOT_IT_ACTION_LABEL = "Got it";
export const SEARCH_GOOGLE_TRANSLATE_LABEL = "Search in Google Translate";
export const SEARCH_GOOGLE_LABEL = "Search in Google";
export const IGNORE_ACTION_LABEL = "Ignore";
export const COPY_TO_CLIPBOARD_LABEL = "Copy to clipboard";

export const EVENT_PRIORITIES = {
  BLOB: 0,
  YT_PAGE: 0,
  POPUP: 1,
  TEXT_INPUT: 2,
};

export interface CommonPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onTriggerSearchGoogleTranslate: () => void;
  onTriggerSearchGoogle: () => void;
  onTriggerCopyToClipboard: () => void;
}
